import { i18n } from 'app/utils/i18n';
import { NewDropdown } from 'app/components/ui';

interface VisibilityProps {
  currentValue: string[];
  onValueChange: (value: string) => void;
}

export const VisibilityPicker = ({ currentValue, onValueChange }: VisibilityProps) => {
  const visibilityOptions = [
    {
      label: i18n('tag.visibility.core'),
      value: 'core',
    },
    { label: i18n('tag.visibility.extension'), value: 'extension' },
  ];

  return (
    <NewDropdown currentValue={currentValue} label={i18n('tag.visibility.label')} options={visibilityOptions} onUpdate={onValueChange} multiselect={true} />
  );
};
